import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { mergeMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as reportActions from 'src/app/root-store/reporting-store/powerbi-report.actions';
import { ReportsService } from 'src/app/reporting/reports/services/reports.service';
import { BaseEffect } from 'src/app/shared/effects/base-effect';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class PowerBiReportEffects extends BaseEffect {
    exportPowerBiReport$ = createEffect(() =>
        this.actions.pipe(
            ofType(reportActions.exportPowerBiReport),
            mergeMap((action) =>
                this.reportService.exportToFile(action.id, action.requestModel).pipe(
                    map((res) => reportActions.exportPowerBiReportSuccess({ status: res })),
                    catchError((error) => of(reportActions.exportPowerBiReportFail({ error })))
                )
            )
        )
    );

    exportPowerBiReportFailed$ = createEffect(
        () =>
            this.actions.pipe(
                ofType(reportActions.exportPowerBiReportFail),
                tap((error) => {
                    this.handleError(error.error);
                })
            ),
        { dispatch: false }
    );

    getPowerBiReportExportStatus$ = createEffect(() =>
        this.actions.pipe(
            ofType(reportActions.getPowerBiReportExportStatus),
            mergeMap((action) =>
                this.reportService.getExportStatus(action.id, action.exportId).pipe(
                    map((res) => reportActions.getPowerBiReportExportStatusSuccess({ status: res })),
                    catchError((error) => of(reportActions.getPowerBiReportExportStatusFail({ error })))
                )
            )
        )
    );

    getPowerBiReportExportStatusFailed$ = createEffect(
        () =>
            this.actions.pipe(
                ofType(reportActions.getPowerBiReportExportStatusFail),
                tap((error) => {
                    this.handleError(error.error);
                })
            ),
        { dispatch: false }
    );

    constructor(
        private readonly actions: Actions,
        private readonly reportService: ReportsService,
        toasterService: ToasterService
    ) {
        super(toasterService);
    }
}
